<template>
  <div class="categories" style="background-color: #111130;">
    <v-card-text >
      <v-row>

        <v-col cols="12" >
          <strong>{{ $t('submitRequest') }}</strong>
        </v-col>
          <v-col cols="3" v-for="item in items" :key="item.Id">
          <div  >
            <div  v-on:click="goToDetail(item.Id)">
              <div class="row" style="text-align: center">
                <div class="col-12">
                  <img style="width: 80%;height: auto;padding: 7px;background: #F3F3F3;border-radius: 10px;" :src="item.ImageUrl" />
                </div>
                <div class="col-12" style="text-align: center">
            <span class="name" style="font-size: 12px;text-align: center;line-height: 1.1rem;color: black;font-weight: bold;">
              {{item.ProductTypeTitle}}
            </span>
                </div>
              </div>

            </div>

          </div>
        </v-col>

      </v-row>
      <v-row>

        <v-col cols="12" style="margin-top: 20px">
          <strong>{{ $t('submitQuestion') }}</strong>
        </v-col>
        <v-col cols="3" >
          <div  >
            <div  v-on:click="go_to_add_question(true)">
              <div class="row" style="text-align: center">
                <div class="col-12">
                  <img style="width: 80%;height: auto;padding: 7px;background: #F3F3F3;border-radius: 10px;"
                       src="/img/add_question.svg" />
                </div>
                <div class="col-12" style="text-align: center">
            <span class="name" style="font-size: 12px;text-align: center;line-height: 1.1rem;color: black;font-weight: bold">
              {{ $t('submitQuestion') }}
            </span>
                </div>
              </div>

            </div>

          </div>
        </v-col>

      </v-row>
    </v-card-text>
  </div>
</template>
<script>
  export default {
    props:[
      'passing_data'
    ],
    data () {
      return {
        errors: [],
        items:[],
        rules: {
          required: value => !!value || this.$t('necessary'),
          fullName: value => value.length <= 30 || this.$t('max30Character'),
          PersianFullName: value => {
            const pattern = /^[پچجحخهعغآ؟.،آفقثصضشسیبلاتنمکگوئدذرزطظژ!!ؤإأءًٌٍَُِّ\s]+$/
            return pattern.test(value) || this.$t('nameNotFarsi')
          },
          mobile: value => {
            const pattern = /^(\+98|0098|98|0)?9\d{9}$/
            return pattern.test(value) || this.$t('phoneNotCorrect')
          },
        },
      }
    },
watch: {

    },
mounted () {
  var passing_data = JSON.parse(localStorage.getItem('request_data'))
  console.log('categories passing_data',passing_data)
      this.get_categories()
    },
    methods: {
      go_to_add_question () {
        this.$router.push({ name:'AddQuestion', params:{} })
      },
      goToDetail (item_id) {
        var PassingData = {}
        localStorage.setItem('request_data', JSON.stringify(PassingData))
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        passing_data.cat_id = item_id
        passing_data.request_name = this.$t('repair')
        localStorage.setItem('request_data', JSON.stringify(passing_data))

        this.$router.push({ name: 'groups', params: {} })
      },
      get_categories () {
        var self = this
          const send_data = {
            Phone: this.mobile,
          }
          // this.axios.post('/Register' , send_data,{
          this.axios.post('/GetRequestTypeList', send_data, {})
            .then(response => {
              if (response.data.error == 0) {
                console.log('response', response)
                // self.user_registered = true;
                // self.fullName = response.data.msg;
                // self.level = 2;
                self.items = response.data.Types
              } else {
                self.not_register = true
              }
              // this.$router.push({ path: "/post-login", params: {} });
            }).catch(e => {
            this.errors.push(e)
          })
      }
    }
  }
</script>
